import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.1464 12.3536L9.35355 18.1465C9.03857 18.4615 8.5 18.2384 8.5 17.7929L8.5 6.20716C8.5 5.7617 9.03857 5.53862 9.35355 5.8536L15.1464 11.6465C15.3417 11.8418 15.3417 12.1583 15.1464 12.3536Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgTriangleRight;
